import { createFileRoute } from "@tanstack/react-router";
import { HistoryPage } from "@/routes/_main/exams/$slug/history";

export const Route = createFileRoute("/_main/groups/$gid/exams/$slug/history")({
  component: HistoryPage,
});
